import {useContext, useEffect} from "react"
import {candidateAppContext, CandidateContextType} from "../../pages/MainPageCandidate"
import {useQuery} from "react-query"
import {NetworkEndpoints} from "../../models/NetworkEndpoints"
import {getQueryByTempTokenNetwork, getQueryNetwork} from "../../networks/getNetwork"
import CandidateCard from "../common/CandidateCard"
import {RouteFrontEnd} from "../../models/RouteFrontEnd"
import {useNavigate} from "react-router-dom"
import CandidateConsentDialog from "./CandidateConsentDialog"
import {ProgressSpinner} from "primereact/progressspinner";

const CandidateContent = () => {
    const {candidateData, setCandidateData} = useContext(candidateAppContext)
    const queryByTokenType = candidateData.isLogin ? getQueryNetwork : getQueryByTempTokenNetwork
    const {
        isLoading,
        data
    } = useQuery([NetworkEndpoints.CANDIDATE_BY_ID, candidateData.id], queryByTokenType, {staleTime: 60000, enabled: !!candidateData.id})
    const navigate = useNavigate()

    const addExperience = () => {
        if(candidateData.isLogin) {
            navigate(`/${RouteFrontEnd.CANDIDATE}/${RouteFrontEnd.EXPERIENCES}/new`)
        }else{
            navigate(`/${RouteFrontEnd.CANDIDATE}/${candidateData.id}/${RouteFrontEnd.EXPERIENCES}/new`)
        }
    }

    const header = <div />


    const isConsentGiven = (!(data?.dataProcessingConsent === "NotGiven") || candidateData.isConsentGiven)

    if (isLoading) return <ProgressSpinner/>

    return (
        <>
            <CandidateConsentDialog token={candidateData.id} isConsentGiven={isConsentGiven}/>
            <CandidateCard header={header} data={data} onClick={() => window.location.href = `mailto:${data.email}`} addExperience={addExperience} />
        </>
    )
}
export default CandidateContent